export default __webpack_public_path__ + "static/media/linkedin.1390e052.svg";